var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var handleMultiHeaderClick = function (_a) {
    var headerGroupItems = _a.headerGroupItems, rowOption = _a.rowOption, value = _a.value, handleOnChange = _a.handleOnChange;
    var groupedItemsArray = [];
    for (var i = 0; i < value.length; i++) {
        if (!value[i].disabled && !value[i].header && value[i].groupId === rowOption.groupId) {
            groupedItemsArray.push(value[i]);
        }
    }
    // if header is clicked, and not all are selected, select all in group, else remove all in group
    if (!groupedItemsArray.length || groupedItemsArray.length !== headerGroupItems.length) {
        // using new set here to remove duplicates.
        var dedupedArray = Array.from(new Set(__spreadArray(__spreadArray([], value, true), headerGroupItems, true)));
        handleOnChange(dedupedArray);
    }
    else if (groupedItemsArray.length === headerGroupItems.length) {
        var returnOptions = [];
        for (var i = 0; i < value.length; i++) {
            if (!value[i].groupId || value[i].groupId !== rowOption.groupId) {
                returnOptions.push(value[i]);
            }
        }
        handleOnChange(returnOptions);
    }
};
